export default __webpack_public_path__ + "static/media/MobileImageItemKo2.c8551919.png";